import BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy from './BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy'
import BillingSummaryCSVPreviewUtils from './BillingSummaryCSVPreviewUtils'
import BillingSummaryCSVPreviewBillingTypesSection from './BillingSummaryCSVPreviewBillingTypesSection'
import BillingSummaryCSVPreviewHeader from './BillingSummaryCSVPreviewHeader'
import BillingSummaryCSVPreviewGroupingSection from './BillingSummaryCSVPreviewGroupingSection'
import CSVParametersBuilder from '../CSVParametersBuilder'
import CSVParametersSection from '../CSVParametersSection'
import BillingSummaryCSVPreviewTimeOnBillableTasksStrategy from './BillingSummaryCSVPreviewTimeOnBillableTasksStrategy'
import BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy from './BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy'
import BillingSummaryCSVPreviewBillableAmountStrategy from './BillingSummaryCSVPreviewBillableAmountStrategy'
import BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy from './BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy'
import CSVPreviewEmptySection from '../CSVPreviewEmptySection'
import {BillingSummaryReportInfo} from 'constants'

export default function BillingSummaryCSVPreviewGenerator() {}
BillingSummaryCSVPreviewGenerator.prototype.init = function ()
{
    return this;
};

BillingSummaryCSVPreviewGenerator.prototype.generatePreviewTable = function ( reportParameters, reportParamsStringBuilder )
{
    var numOfGroupingColumns = BillingSummaryCSVPreviewUtils.getNumberOfGroupingLevelsCells(
                                                                           reportParameters.firstGroupingLevel,
                                                                           reportParameters.secondGroupingLevel,
                                                                           reportParameters.thirdGroupingLevel );
    var numOfDataRows = 5;

    var columnsStrategy = this.createPreviewStrategy( reportParameters.reportInfo );

    var totalColumnsNum = numOfGroupingColumns + columnsStrategy.getNumOfDataColumns();
    var totalRowNum = 18;

    var billingTypesSection = new BillingSummaryCSVPreviewBillingTypesSection().init( totalColumnsNum );

    var header = new BillingSummaryCSVPreviewHeader().init(
            reportParameters.firstGroupingLevel,
            reportParameters.secondGroupingLevel,
            reportParameters.thirdGroupingLevel,
            reportParameters.reportInfo,
            columnsStrategy,
            numOfGroupingColumns
    );

    const dataGroupingSection = new BillingSummaryCSVPreviewGroupingSection().init(
        reportParameters.firstGroupingLevel,
        reportParameters.secondGroupingLevel,
        reportParameters.thirdGroupingLevel,
        columnsStrategy,
        numOfGroupingColumns,
        numOfDataRows,
        reportParameters.reportAuthorizationInfo,
    )

    var table = document.createElement( "table" );
    table.className = "reportCsvPreviewTable billingSummaryCsvPreview" + (numOfGroupingColumns == 4 ? " fourGroupingLevels" : "");
    var tBody = document.createElement( "tbody" );
    table.appendChild( tBody );

    ReportPreviewUtils.addSheetHeaderRow( tBody, totalColumnsNum );

    var paramsBuilder = new CSVParametersBuilder().init();
    paramsBuilder.addBillingSummaryReportTypeParam( reportParameters.reportType );
    paramsBuilder.addDateRangeParam( reportParameters.dateRangeSelection, reportParamsStringBuilder );
    paramsBuilder.addCPParam( reportParameters.customersProjectsSelection, reportParamsStringBuilder );
    paramsBuilder.addBillingSummaryTasksParam( reportParameters.reportInfo );
    if (EnabledFeatures.TTA) {
        paramsBuilder.addTimeTrackStatusParam( reportParameters.timeApprovalStatus );
    }

    var parametersSection = new CSVParametersSection().init( paramsBuilder, totalColumnsNum );

    parametersSection.addRows( tBody );

    if ( this.isNeedToIncludeBillingRatesSection( reportParameters.reportInfo ) )
    {
        billingTypesSection.addRows( tBody );
        this.addSectionSeparator( tBody, totalColumnsNum );
    }

    header.addRows( tBody );
    dataGroupingSection.addRows( tBody );

    this.addEmptySectionIfNeeded( totalRowNum, tBody, totalColumnsNum );

    return table;
};

BillingSummaryCSVPreviewGenerator.prototype.createPreviewStrategy = function ( reportInfo )
{
    switch ( reportInfo )
    {
        case BillingSummaryReportInfo.TIME_ON_BILLABLE_TASKS:
            return new BillingSummaryCSVPreviewTimeOnBillableTasksStrategy().init();
            break;
        case BillingSummaryReportInfo.TIME_ON_NON_BILLABLE_TASKS:
            return new BillingSummaryCSVPreviewTimeOnNonBillableTasksStrategy().init();
            break;
        case BillingSummaryReportInfo.TIME_ON_BOTH_BILLABLE_AND_NON_BILLABLE_TASKS:
            return new BillingSummaryCSVPreviewTimeOnBothBillableAndNonBillableTasksStrategy().init();
            break;
        case BillingSummaryReportInfo.BILLABLE_AMOUNT:
            return new BillingSummaryCSVPreviewBillableAmountStrategy().init();
            break;
        case BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT:
        case BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES:
            return new BillingSummaryCSVPreviewBillableTimeAndBillableAmountStrategy().init( reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES );
            break;
    }
};

BillingSummaryCSVPreviewGenerator.prototype.isNeedToIncludeBillingRatesSection = function ( reportInfo )
{
    return reportInfo == BillingSummaryReportInfo.BILLABLE_AMOUNT || reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT
           || reportInfo == BillingSummaryReportInfo.BILLABLE_TIME_AND_BILLABLE_AMOUNT_WITH_AVERAGE_RATES;
};

BillingSummaryCSVPreviewGenerator.prototype.addSectionSeparator = function ( tBody, totalColumnsNum )
{
    new CSVPreviewEmptySection().init( 1, totalColumnsNum ).addRows( tBody );
};

BillingSummaryCSVPreviewGenerator.prototype.addEmptySectionIfNeeded = function ( totalRowsNum, tBody, totalColumnsNum )
{
    var numOfEmptyRows = totalRowsNum + 1 - tBody.childNodes.length;
    if ( numOfEmptyRows > 0 )
        new CSVPreviewEmptySection().init( numOfEmptyRows, totalColumnsNum ).addRows( tBody );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/billingsummary/BillingSummaryCSVPreviewGenerator.js